import validate from '../lib';
import variousSettingsValidator from './variousSettingsValidation';
import variousEntitySettingsValidator from './variousEntitySettingsValidation';
import contactOriginValidator from './contactOriginValidation';
import simulationSettingsValidator from './simulationSettingsValidation';
import summarySettingsValidator from './summarySettingsValidation';
import { baseProductValidators, typeValidators } from './lifeInsuranceSettingsValidation';
import { scpiValidators, dismemberedScpiValidators } from './scpiSettingsValidation';
import { contractValidators, basePerValidators } from './perSettingsValidation';
import { managementActValidators } from './managementActSettingsValidation';
import businessPartnerSettingsValidator from './businessPartnerValidation';

// validate file
const validateScpi = (product, distribution) => validate(scpiValidators(product, distribution));
const validateDismemberedScpi = (product, distribution) => validate(dismemberedScpiValidators(product, distribution));
const validateLifeInsurance = (type) => validate(typeValidators(type));
const validateBaseProducts = (product) => validate(baseProductValidators(product));
const validateSupports = (product) => validate(basePerValidators(product));
const validatePer = (contract) => validate(contractValidators(contract));
const validateManagementAct = (partner) => validate(managementActValidators(partner));

export const typeToValidation = {
    scpi: validateScpi,
    dismemberedScpi: validateDismemberedScpi,
    lifeInsurance: validateLifeInsurance,
    baseProducts: validateBaseProducts,
    per: validatePer,
    supports: validateSupports,
    managementAct: validateManagementAct,
};

export const validateSimulationSettings = (settings) => validate(simulationSettingsValidator(settings))(settings);
// les partenaires ne sont pas des settings : ils ont leur propre validation
export const validateBusinessPartners = (businessPartners) => validate(businessPartnerSettingsValidator(businessPartners))(businessPartners);
export const validateVariousSettings = (settings) => validate(variousSettingsValidator)(settings);
export const validateVariousEntitySettings = (settings) => validate(variousEntitySettingsValidator)(settings);
export const validateContactOriginSettings = (settings) => validate(contactOriginValidator)(settings);

export default (settings) => validate([
    ...simulationSettingsValidator(settings),
    ...variousSettingsValidator,
    ...summarySettingsValidator,
])(settings);
